import type { ActivityEntry } from '@mas-flow/types';
import { ApiHttpError } from './client';

export async function listForItem(itemId: string): Promise<ActivityEntry[]> {
  const res = await fetch(`/api/items/${encodeURIComponent(itemId)}/activity`, { credentials: 'include' });
  if (!res.ok) {
    const payload = await res.json().catch(() => undefined);
    throw new ApiHttpError(res.status, payload as { error: string; detail?: string } | undefined);
  }
  const { entries } = (await res.json()) as { entries: ActivityEntry[] };
  return entries;
}
